module.exports = __webpack_public_path__ + "static/media/calendartime.47a88092.svg";